import { AggregationType } from '@y42/json-schema';
import { FormatConfig } from '@y42/model';
import { fieldId } from '../field-id.model';
import { defaultNumericDimensionConfig, NumericDimensionConfig } from '../numeric-dimension.model';
import { BaseEchartsSettingsModel, MarkTypeEnum } from './base-echart-settings.model';
import { ColorModel } from './sub-models/color.model';
import { DatosAxisPointer } from './sub-models/datos-axis.model';
import { LabelModel } from './sub-models/label.model';

export const defaultNumericColor = {
  increase: '#52BD95',
  decrease: '#F36331',
};

export class NumericWidgetSettingsModel extends BaseEchartsSettingsModel<NumericWidgetModel> {
  constructor(
    series: NumericWidgetModel[] = [],
    show_legend?: boolean,
    axisPointer?: DatosAxisPointer,
    breakdowns?: fieldId[],
    public absoluteChange = false,
    public mainPeriod: NumericDimensionConfig['mainPeriod'] = defaultNumericDimensionConfig.mainPeriod,
    public comparisonPeriod: NumericDimensionConfig['comparisonPeriod'] = defaultNumericDimensionConfig.comparisonPeriod,
    public increaseColor = defaultNumericColor.increase,
    public decreaseColor = defaultNumericColor.decrease,
  ) {
    super(series, show_legend, axisPointer, [], breakdowns);
  }
}

export class NumericWidgetModel {
  constructor(
    public field_id: fieldId | null = null,
    public mark: MarkTypeEnum = MarkTypeEnum.Bar,
    public stack_name = 1, // need as unique id
    public color: ColorModel = new ColorModel(),
    public label: LabelModel = new LabelModel(),
    public show_tooltip = true,
    public show_right_axis = false,
    public format = 'inherit',
    public formatConfig?: FormatConfig,
  ) {}
}

export const numericFieldAggregationModel = {
  value: ' - ' as AggregationType,
  display_name: ' - ',
} as const;
